import { X } from "lucide-react";
import { useId, type ReactNode } from "react";
import { IconButton } from "./IconButton";
import { useOverlay } from "./useOverlay";

export function FormDrawer({
  title,
  description,
  eyebrow,
  children,
  footer,
  onClose,
  size = "md",
}: {
  title: string;
  description?: string;
  eyebrow?: string;
  children: ReactNode;
  footer?: ReactNode;
  onClose: () => void;
  size?: "sm" | "md" | "lg" | "xl";
}) {
  const titleId = useId();
  const drawerRef = useOverlay<HTMLElement>(onClose);

  return (
    <div
      className="drawer-overlay side-drawer-backdrop"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <IconButton
        className={`close-btn-outside side-drawer__outside-close side-drawer__outside-close--${size}`}
        label="Fechar formulário"
        onClick={onClose}
      >
        <X />
      </IconButton>
      <aside
        ref={drawerRef}
        className={`drawer-content side-drawer side-drawer--${size}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
      >
        <header className="side-drawer__header">
          <div>
            {eyebrow && <span className="eyebrow">{eyebrow}</span>}
            <h2 id={titleId}>{title}</h2>
            {description && <p>{description}</p>}
          </div>
          <IconButton
            className="side-drawer__header-close"
            label="Fechar formulário"
            onClick={onClose}
          >
            <X />
          </IconButton>
        </header>
        <div className="drawer-body side-drawer__body">{children}</div>
        {footer && <footer className="side-drawer__footer">{footer}</footer>}
      </aside>
    </div>
  );
}
